module.exports = __webpack_public_path__ + "static/media/pdf.e2ca98fe.svg";